<div class="modal-header">
    <div class="modal-title">Selecciona una empresa</div>
    <button mat-icon-button class="close-button" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="modal-body py-4" style="max-height: none; overflow: visible;">
    <div *ngIf="isLoadingData" class="text-center py-4">
        <div class="spinner-border text-danger" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2">Cargando empresas...</p>
    </div>

    <div *ngIf="!isLoadingData">
        <label for="tenantSelect">Empresa <span style="color: #FF3333;"><b>*</b></span></label>
        <input *ngIf="user?.tenant_id; else allTenants" type="text" class="form-control" readonly
            [value]="tenant?.name">
        <ng-template #allTenants>
            <select class="form-control" id="tenantSelect" [value]="selectedTenant">
                <option value="">Seleccione una empresa</option>
                <option *ngFor="let tenant of filteredTenants" [value]="tenant.slug">
                    <div class="flex items-center gap-2">
                        <img *ngIf="tenant.logo" [src]="(tenant | image:'tenant_escudo' | async) || 'assets/img/noimage.png'"
                            alt="{{ tenant.name }}" width="20" height="20">
                        {{ tenant.name }}
                    </div>
                </option>
            </select>
        </ng-template>
    </div>
</div>

<div class="text-center mt-1" *ngIf="!isLoadingData">
    <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-danger btn-selectedTenant" *ngIf="!loadingButton" [disabled]="!selectedTenant"
            (click)="onConfirm()">
            Ingresar
        </button>
        <button type="button" class="btn btn-danger btn-selectedTenant" *ngIf="loadingButton" disabled>
            <i class="fa fa-spinner fa-pulse"></i>
            Ingresar
        </button>
    </div>
</div>